import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0041',
    ecrans: ['00-2'],
    params: ['id']
});
